export const getValueByType = (arr, type) =>
  arr.find(i => i.type === type)?.value
